













import { defineComponent } from '@vue/composition-api';
import SimpleCard from '../SimpleCard.vue';

export default defineComponent({
	components: {
		SimpleCard,
	},
	props: {
		count: {
			type: Number,
			required: true,
		},
	},
	setup() {
		return {};
	},
});
